// import React from 'react';
// import Card from './../components/Commanbackgroundcard/Card';
// import Navbar from '../components/Navbar/Navbar';
// import Footer from './../components/Footer/Footer'
// import './About.css'

// const About = () => {
//   return (
//     <div>
//         <Navbar/>
//         <Card text="ABOUT US" />
//         <div className='body'>
//               <div class="container w-[95%] m-auto">

//                   <p className='lg:text-lg md:text-base sm:text-base text-base'>Industrial Automation has been a systems integrator for the past 30 years serving a wide variety of manufacturing clients throughout the Midwest. Through the combined experience of our technical staff and business partners, we can design and build automated control systems that will increase the <span class="highlight">safety</span>, <span class="highlight">quality</span>, <span class="highlight">productivity</span>, and <span class="highlight">efficiency</span> of your operation.</p>

//                   <p className='lg:text-lg md:text-base sm:text-base text-base'>No matter how unique your production needs, we are committed to the development of control systems that will reduce your cost of doing business.</p>

//                   <p className='lg:text-lg md:text-base sm:text-base text-base'>Today’s ever-changing technology offers new and innovative ways to approach automation and control issues. To take advantage of these new technologies, you need a partner who understands how to apply them to your needs. From concept to production, we are committed to developing, building, and maintaining quality automation systems that assist you in meeting your company’s production goals.</p>

//                   <p className='lg:text-lg md:text-base sm:text-base text-base'>Our experience with the following automation solutions can be put to work for your company:</p>
                  
//                   <ul className='lg:text-lg md:text-base sm:text-base text-base'>
//                       <li>Robotics</li>
//                       <li>PLCs</li>
//                       <li>Touch screens</li>
//                       <li>Machine vision</li>
//                       <li>Pneumatic control</li>
//                       <li>Hydraulic control</li>
//                       <li>Motion control</li>
//                       <li>Process control systems</li>
//                   </ul>

//                   <p className='lg:text-lg md:text-base sm:text-base text-base'>We will reduce downtime & waste, improve quality, increase efficiency and productivity, enhance safety, and reduce energy costs. Current economic conditions dictate that your operation must produce as efficiently and reliably as possible.</p>

//                   <p className='lg:text-lg md:text-base sm:text-base text-base'>Industrial Automation works closely with our customers to develop new systems or to cost-effectively enhance the capabilities of existing machines to meet your requirements.</p>
//               </div>
//         </div>
//         <Footer/>
//     </div>
//   )
// }

// export default About



import React from 'react';
import Card from './../components/Commanbackgroundcard/Card';
import Navbar from '../components/Navbar/Navbar';
import Footer from './../components/Footer/Footer';
import automationabout from './../components/Assets/automationabout.webp';
import './About.css';
import { CheckCircle, Globe2, Award, Users, Box } from "lucide-react";
import certificate1 from '../components/Assets/certificate1.jpg';
import certificate2 from '../components/Assets/certificate2.jpg';
import certificate3 from '../components/Assets/certificate3.jpg';


const About = () => {
  return (
    <div className="min-h-screen relative">
      <Navbar />
      <Card text="ABOUT US" />
      <section className="w-full bg-gray-100 py-12 relative z-10">
  <div className="container mx-auto flex flex-col md:flex-row items-center px-6 lg:px-12 gap-8">
    
    {/* Left Side - Image */}
    <div className="w-full md:w-1/2 flex justify-center">
      <img
        src={automationabout}
        alt="Automation Illustration"
        className="w-4/5 md:w-full max-w-md"
      />
    </div>

    {/* Right Side - Text Content */}
    <div className="w-full md:w-1/2 text-center md:text-left">
      <h2 className="text-3xl lg:text-4xl font-bold text-blue-800 mb-4">
        Engineering the Future of Automation
      </h2>
      <p className="text-lg text-gray-600">
        Metrolab Automation Pvt. Ltd. is a pioneering force in the field of engineering,
        automation, and robotics. Established over 14 years ago, we have consistently pushed
        the boundaries of innovation, providing comprehensive solutions that empower industries
        and enhance operational efficiency across the globe. Headquartered in Pune, India,
        our company is built on a foundation of integrity, dedication, and a relentless pursuit
        of excellence.
      </p>
    </div>
  </div>
</section>

{/* 🔹 Our Journey + Mission + Vision + Values Section */}
<section className="w-full bg-white py-16">
  <div className="container mx-auto px-6 lg:px-12">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
      
      {/* Our Vision */}
      <div className="bg-gray-50 rounded-xl p-8 shadow-md flex flex-col">
        <div className="flex items-center mb-4">
          <div className="bg-purple-100 text-purple-800 p-3 rounded-full mr-4">
            <span className="text-4xl">👁️</span>
          </div>
          <h2 className="text-3xl font-bold text-blue-800">Our Vision</h2>
        </div>
        <p className="text-gray-700 leading-relaxed">
          To empower our customers through sincerity, dedication, and a commitment to coexistence and growth
          in both the Indian and international markets.
        </p>
      </div>
      
      {/* Our Mission */}
      <div className="bg-gray-50 rounded-xl p-8 shadow-md flex flex-col justify-between">
        <div className="flex items-center mb-4">
          <div className="bg-green-100 text-green-800 p-3 rounded-full mr-4">
            <span className="text-4xl">🎯</span>
          </div>
          <h2 className="text-3xl font-bold text-blue-800">Our Mission</h2>
        </div>
        <p className="text-gray-700 leading-relaxed">
          Our mission is to foster a corporate culture that promotes growth and innovation. 
          We are committed to creating an environment where employees can thrive, while focusing 
          on core technologies and products that strengthen our manufacturing excellence. 
          By delivering consistent quality and maintaining strong customer relationships, 
          we continue to push the boundaries of engineering and automation worldwide.
        </p>
      </div>

      {/* Our Journey */}
      <div className="bg-gray-50 rounded-xl p-8 shadow-md flex flex-col justify-between">
        <div className="flex items-center mb-4">
          <div className="bg-blue-100 text-blue-800 p-3 rounded-full mr-4">
            <span className="text-4xl">🚀</span>
          </div>
          <h2 className="text-3xl font-bold text-blue-800">Our Journey</h2>
        </div>
        <p className="text-gray-700 leading-relaxed">
          Founded with a vision to contribute to the industry through sincerity and dedication,
          <span className="font-semibold text-blue-700"> Metrolab Automation Pvt. Ltd. </span>
          has evolved into a trusted partner for businesses worldwide. From humble beginnings,
          we have expanded our capabilities and offerings to become a leader in automation,
          robotics, and engineering services.
        </p>
      </div>

      {/* Our Values */}
      <div className="bg-gray-50 rounded-xl p-8 shadow-md flex flex-col justify-between">
        <div className="flex items-center mb-4">
          <div className="bg-yellow-100 text-yellow-800 p-3 rounded-full mr-4">
            <span className="text-4xl">💎</span>
          </div>
          <h2 className="text-3xl font-bold text-blue-800">Our Values</h2>
        </div>
        <p className="text-gray-700 leading-relaxed">
          Metrolab Automation Pvt. Ltd. stands for quality, integrity, and continuous improvement.
          We are dedicated to providing exceptional engineering and automation solutions by upholding 
          the highest standards in safety, performance, and customer satisfaction. Our commitment 
          to ethical practices and sustainable development drives us to innovate responsibly while 
          fostering a culture of trust and excellence.
        </p>
      </div>

    </div>
  </div>
</section>


{/* What Sets Us Apart Section */}
<section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          What Sets Us Apart
        </h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-12">
          Metrolab Automation Pvt. Ltd. is more than just a company; we are a
          team of passionate professionals dedicated to making a difference in
          the world of engineering and automation.
        </p>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="bg-white shadow-md rounded-2xl p-6 text-left flex flex-col items-start">
            <CheckCircle className="w-12 h-12 text-yellow-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Expertise & Experience
            </h3>
            <p className="text-gray-600">
              With over 14 years of experience, we deliver high-quality
              engineering and automation solutions.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white shadow-md rounded-2xl p-6 text-left flex flex-col items-start">
            <Box className="w-12 h-12 text-yellow-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Diverse Product Range
            </h3>
            <p className="text-gray-600">
              From automation solutions to ergonomic lift systems, we provide a
              wide variety of products.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white shadow-md rounded-2xl p-6 text-left flex flex-col items-start">
            <Globe2 className="w-12 h-12 text-yellow-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Global Reach & Impact
            </h3>
            <p className="text-gray-600">
              Our projects span across Europe, North America, Asia, and Africa.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white shadow-md rounded-2xl p-6 text-left flex flex-col items-start">
            <Award className="w-12 h-12 text-yellow-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Commitment to Quality
            </h3>
            <p className="text-gray-600">
              We are ISO 9001-2015 certified and ECOVADIS CSR Silver Medal 2023
              recipients.
            </p>
          </div>

          {/* Card 5 */}
          <div className="bg-white shadow-md rounded-2xl p-6 text-left flex flex-col items-start">
            <Users className="w-12 h-12 text-yellow-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Strategic Partnerships
            </h3>
            <p className="text-gray-600">
              We collaborate with international partners to deliver seamless
              global solutions.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* 🔹 Our Facilities Section */}
{/* <section className="py-16 bg-gray-100">
  <div className="container mx-auto px-6 lg:px-12 text-center">
    <h2 className="text-3xl font-bold text-blue-800 mb-12">Our Facilities</h2>
    <p className="text-gray-700 text-lg mb-12">
      Metrolab Automation Pvt. Ltd. operates two state-of-the-art plants in Pune, India.
    </p>

   
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
      
     
      <div className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col">
        <img
          src="/images/plant1.jpg" 
          alt="Plant 1"
          className="w-full h-64 object-cover"
        />
        <div className="p-6 flex flex-col justify-between flex-1">
          <h3 className="text-xl font-bold text-gray-800 mb-2">Plant 1</h3>
          <p className="text-gray-600">
            A 6,500 sq. ft. facility dedicated to automation assembly and trials.
          </p>
        </div>
      </div>

   
      <div className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col">
        <img
          src="/images/plant2.jpg" 
          alt="Plant 2"
          className="w-full h-64 object-cover"
        />
        <div className="p-6 flex flex-col justify-between flex-1">
          <h3 className="text-xl font-bold text-gray-800 mb-2">Plant 2</h3>
          <p className="text-gray-600">
            A 14,000 sq. ft. expansion plant under development to meet growing global demand.
          </p>
        </div>
      </div>

    </div>
  </div>
</section> */}

{/* 🔹 Certifications Section */}
<section className="py-16 bg-gray-50">
  <div className="container mx-auto px-6 lg:px-12 text-center">
    <h2 className="text-4xl font-bold text-blue-800 mb-12 pt-[25px]">
      Certifications
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {/* Certificate 1 */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <img
          src={certificate1} // import or path
          alt="Certificate 1"
          className="w-full h-75 object-cover"
        />
      </div>

      {/* Certificate 2 */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <img
          src={certificate2} // import or path
          alt="Certificate 2"
          className="w-full h-75 object-cover"
        />
      </div>

      {/* Certificate 3 */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <img
          src={certificate3} // import or path
          alt="Certificate 3"
          className="w-full h-75 object-cover"
        />
      </div>
    </div>
  </div>
</section>



      {/* <div className="body">
        <div className="container mx-auto w-[100%] lg:w-[85%] md:w-[85%] sm:w-[85%] mt-10 p-4">
          <p className="about-text my-4">
            <span className="highlight">Metrolab Automation Pvt. Ltd. </span> is a pioneering force in the field of engineering, automation, and robotics. Established over 14 years ago, we have consistently pushed the boundaries of innovation, providing comprehensive solutions that empower industries and enhance operational efficiency across the globe. Headquartered in Pune, India, our company is built on a foundation of integrity, dedication, and a relentless pursuit of excellence.
          </p>

          <h2 className="text-2xl font-bold text-blue-800 mt-6">Our Journey</h2>
          <p className="about-text my-4">
            Founded with a vision to contribute to the industry through sincerity and dedication, Metrolab Automation Pvt. Ltd. has evolved into a trusted partner for businesses worldwide. From humble beginnings, we have expanded our capabilities and offerings to become a leader in automation, robotics, and engineering services.
          </p>

          <h2 className="text-2xl font-bold text-blue-800 mt-6">Our Mission</h2>
          <p className="about-text my-4">
            Our mission is to foster a corporate culture that promotes growth and innovation. We aim to:
          </p>
          <ul className="list-disc pl-5 about-text">
            <li>Establish a dynamic environment that empowers employees to excel and drive the company's success.</li>
            <li>Focus on core technologies and products to continuously enhance our manufacturing capabilities.</li>
            <li>Deliver the highest standards of service through a highly skilled team of field representatives and customer service professionals.</li>
          </ul>

          <h2 className="text-2xl font-bold text-blue-800 mt-6">What Sets Us Apart</h2>
          <p className="about-text my-4">
            Metrolab Automation Pvt. Ltd. is more than just a company; we are a team of passionate professionals dedicated to making a difference in the world of engineering and automation.
          </p>

          <ul className="list-disc pl-5 about-text my-4">
            <li>Expertise and Experience: With over 14 years of experience, we deliver high-quality engineering and automation solutions.</li>
            <li>Diverse Product Range: From automation solutions to ergonomic lift systems, we provide a variety of products.</li>
            <li>Global Reach and Impact: Our projects span across Europe, North America, Asia, and Africa.</li>
            <li>Commitment to Quality: We are ISO 9001-2015 certified and ECOVADIS CSR Silver Medal 2023 recipients.</li>
            <li>Strategic Partnerships: We collaborate with international partners to deliver seamless global solutions.</li>
          </ul>

          <h2 className="text-2xl font-bold text-blue-800 mt-6">Our Facilities</h2>
          <p className="about-text my-4">
            Metrolab Automation Pvt. Ltd. operates two state-of-the-art plants in Pune, India.
          </p>
          <ul className="list-disc pl-5 about-text">
            <li>Plant 1: A 6,500 sq. ft. facility dedicated to automation assembly and trials.</li>
            <li>Plant 2: A 14,000 sq. ft. expansion plant under development to meet growing global demand.</li>
          </ul>

          <h2 className="text-2xl font-bold text-blue-800 mt-6">Our Clients and Projects</h2>
          <p className="about-text my-4">We take pride in our projects across various industries:</p>
          <ul className="list-disc pl-5 about-text">
            <li>Czech Republic – US Welding SPM</li>
            <li>Italy – US Welding SPM, Leak Testing SPM</li>
            <li>South Africa – US Welding SPM, Post Process SPM</li>
            <li>UAE – Aerospace Equipment</li>
            <li>USA – Consumer Product Solutions</li>
            <li>Thailand – Lift Assist Manipulators</li>
          </ul>

          <h2 className="text-2xl font-bold text-blue-800 mt-6">Certifications</h2>
          <p className="about-text my-4">ISO 9001-2015 certified by TUV Austria, ECOVADIS CSR Silver Medal 2023</p>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default About;
